export const DESCRIPTION_DETECTNAME =
    '(boolean, defaults to false)\n\nWhen true, will attempt to use the name of the queried table as the XML node name for the rows in the result XML.\n\nOtherwise, will use the default row names from the data source.';
export const DESCRIPTION_SQL_DSNAME = 'SQL Data Source Name';
